require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./member-michael-bartolome.json") })
        }
      }, "path---member-michael-bartolome");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---member-michael-bartolome!./.cache/json/member-michael-bartolome.json
// module id = 403
// module chunks = 231608221292675